<template>
    <div>
        <div id="proposal-content-add" data-backdrop="static" data-keyboard="false" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg text-black">
                            {{ proposalContentModalTitle }}
                        </h4>
                        <button type="button" dusk="modal-close-button" @click="proposalContentCancel()"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="mb-2">
                                <div class="form-group">
                                    <label class="text-black font-light text-sm">Content Name</label>
                                    <input  class="form-control"
                                            type="text"
                                            v-model="proposalContentName"
                                            id="proposal_content_name">
                                </div>
                            </div>
                            <div class="mb-2" v-if="proposalContentModalButton !== 'Rename'">
                                <div class="form-group list-all-section-type">
                                    <label class="text-black font-light text-sm">Select Section Type</label>
                                    <multiselect
                                        id="selectSectionType"
                                        v-model="selectedContentType"
                                        :options="allContentType"
                                        :multiple="false"
                                        :close-on-select="true"
                                        :clear-on-select="true"
                                        :preserve-search="false"
                                        :taggable="false"
                                        open-direction="below"
                                        placeholder="Select Content Type"
                                        :showLabels="false"
                                        label="name"
                                        track-by="id"
                                        :preselect-first="false"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div v-if="proposalContentModalButton == 'Save'">
                            <button name="cancel-proposal-template"
                                    @click="proposalContentCancel()"
                                    class="px-3 py-1 rounded-full text-teal focus:outline-none">
                                Cancel
                            </button>
                            <button id="save-proposal-type" name="save-proposal-template"
                                    @click="saveProposalContent()"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                {{ proposalContentModalButton }}
                            </button>
                        </div>
                        <div v-if="proposalContentModalButton == 'Update'">
                            <button name="cancel-proposal-template"
                                    @click="proposalContentCancel()"
                                    class="px-3 py-1 rounded-full text-teal focus:outline-none">
                                Cancel
                            </button>
                            <button  name="update-proposal-template"
                                     @click="updateProposalContent()"
                                     class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                {{ proposalContentModalButton }}
                            </button>
                        </div>
                        <div v-if="proposalContentModalButton == 'Rename'">
                            <button name="cancel-proposal-template"
                                    @click="proposalContentCancel()"
                                    class="px-3 py-1 rounded-full text-teal focus:outline-none">
                                Cancel
                            </button>
                            <button  name="update-proposal-template"
                                     @click="updateProposalContentName()"
                                     class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="proposal-settings-template-div">
            <div class="row">
                <div class="col-md-6 float-left">
                    <h5>Content</h5>
                </div>
                <div class="col-md-6 float-right text-right">
                    <input type="text" placeholder="Search Content" @keyup="fetchproposalContents()" class="form-control" id="searchContent" v-model="searchContentData">
                    <button id="add-proposal-template-section" name="add-proposal-template-section" @click="openProposalContentAddModal()"
                            class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 text-white focus:outline-none rounded add-new-template-button">
                        New Content
                    </button>
                </div>
            </div>
            <div class="proposal-template-listing-div mt-3">
                <div class="proposal-template-listing-heading">
                    <div class="row proposal-template-listing-heading-row pt-2 pb-2 text-black">
                        <div class="col-md-4 float-left cursor-pointer" @click="sortByColumn('template_name')">
                            Content Name

                            <i class="fa fa-xs ml-2"
                               :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                        'fa-chevron-down' : currentOrder.direction === 'desc'}"
                               v-if="currentOrder.sortBy === 'template_name'"></i>
                        </div>
                        <div class="col-md-3 float-left cursor-pointer" @click="sortByColumn('section_type')">
                            Content Type

                            <i class="fa fa-xs ml-2 cursor-pointer"
                               :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                        'fa-chevron-down' : currentOrder.direction === 'desc'}"
                               v-if="currentOrder.sortBy === 'section_type'"></i>
                        </div>
                        <div class="col-md-3 float-left" @click="sortByColumn('updated_at')">
                            Last Updated

                            <i class="fa fa-xs ml-2 cursor-pointer"
                               :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                        'fa-chevron-down' : currentOrder.direction === 'desc'}"
                               v-if="currentOrder.sortBy === 'updated_at'"></i>
                        </div>
                        <div class="col-md-2 float-left">
                        </div>
                    </div>
                </div>
                <div class="proposal-template-listing">
                    <div v-if="proposalContents.length > 0">
                        <div class="row proposal-template-listing-row pt-2 pb-2 text-black" v-for="proposalContent in proposalContents" :id="'proposal-template-row-'+proposalContent.id">
                            <div class="col-md-4 float-left">
                                {{ proposalContent.template_name }}
                            </div>
                            <div class="col-md-3 float-left">
                                <span v-if="proposalContent.section_type == 1">
                                            Standard Content
                                </span>
                                <span v-else-if="proposalContent.section_type == 0">
                                            PDF Content
                                </span>
                                <span v-else-if="proposalContent.section_type == 2">
                                            Excel Content
                                </span>
                                <span v-else-if="proposalContent.section_type == 3">
                                            Quote & Pricing Template
                                </span>
                            </div>
                            <div class="col-md-3 float-left">
                                {{ formatUpdateDate(proposalContent.updated_at) }}
                            </div>
                            <div class="col-md-2 float-left text-right">
                                <div class="dropdown open">
                                    <button type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">
                                        <svg class="fill-current h-4 w-4" enable-background="new 0 0 515.555 515.555"
                                             viewBox="0 0 515.555 515.555" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                            <path
                                                d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                            <path
                                                d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                        </svg>
                                    </button>

                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" @click="manageContent(proposalContent)">Manage</a>
                                        <a class="dropdown-item" @click="renameContent(proposalContent)">Rename</a>
                                        <a class="dropdown-item" @click="duplicateContent(proposalContent)">Duplicate</a>
                                        <a class="dropdown-item" @click="deleteContent(proposalContent)">Delete</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <h5 class="text-black text-center mt-4">
                            {{ proposalContentListingText }}
                        </h5>
                    </div>
                    <div v-if="pagination.total > pagination.per_page" class="flex justify-center mt-3">
                        <b-pagination
                            @change="goToPage"
                            v-model="pagination.current_page"
                            :total-rows="pagination.total"
                            :per-page="pagination.per_page"
                            first-text="First"
                            prev-text="Prev"
                            next-text="Next"
                            last-text="Last"
                        >
                        </b-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";

export default {
    name: "proposal-settings-contents",
    props:[],
    components: {Multiselect},
    data() {
        return {
            proposalContents: [],
            proposalContentListingText: 'Loading Proposal Content',
            page: 1,
            pagination: {
                data: [],
                meta: {},
                links: {},
            },
            proposalContentName:'',
            proposalContentModalButton:'Save',
            proposalContentModalTitle:'Manage Content Name',
            selectedContent:null,
            allContentType:[
                {
                    id:1,
                    name:'Standard/Text Type'
                },
                {
                    id:2,
                    name:'Excel Type'
                },
                {
                    id:3,
                    name:'PDF Type'
                },
                {
                    id:4,
                    name:'Quote & Pricing Template'
                }
            ],
            selectedContentType:[],
            searchContentData:'',
            currentOrder:{
                direction:'',
                sortBy:''
            }
        }
    },
    mounted(){
        this.fetchproposalContents();
    },
    methods: {
        formatUpdateDate(updatedAt){
            return moment.utc(updatedAt).local().format('MM/DD/YYYY hh:mm A')
        },
        goToPage(page) {
            this.page = page;
            this.$nextTick(()=>{
                this.fetchproposalContents();
            });
        },
        fetchproposalContents(){
            if(this.searchContentData.trim() !== ''){
                this.page = 1;
            }
            axios.get(route('api.proposal-content.list', {page: this.page, search:this.searchContentData.trim(), sort:this.currentOrder})).then((response) => {
                let data = response.data;
                if(data.data.length > 0){
                    this.proposalContents = data.data;
                    this.pagination = data;
                }else{
                    this.proposalContents = [];
                    this.proposalContentListingText = 'No proposal content found';
                    this.pagination = data;
                }
            });
        },
        openProposalContentAddModal(){
            $('#proposal-content-add').modal('show');
        },
        proposalContentCancel(){
            $('#proposal-content-add').modal('hide');
            this.proposalContentName = '';
            this.proposalContentModalButton = 'Save';
            this.proposalContentModalTitle = 'Manage content name';
            this.selectedContent = null;
            this.selectedContentType= [];
        },
        saveProposalContent(){
            if(this.proposalContentName.trim() == '' || this.proposalContentName == undefined){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please enter content name'
                });
                return false;
            }
            if(this.selectedContentType.length == 0){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select content type'
                });
                return false;
            }
            axios.post(route('api.proposal-content.add'), {name:this.proposalContentName, contentType:this.selectedContentType}).then((response) => {
                if(response.data.status == 'success'){
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    this.page = 1;
                    this.fetchproposalContents();
                    this.proposalContentCancel();
                    this.manageContent(response.data.content);
                }
            });
        },
        updateProposalContent(){
            if(this.proposalContentName.trim() == '' || this.proposalContentName == undefined){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please enter content name'
                });
                return false;
            }
            axios.post(route('api.proposal-content-group.rename'), {name:this.proposalContentName, content: this.selectedContent}).then((response) => {
                if(response.data.status == 'success'){
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    this.page = 1;
                    this.fetchproposalContents();
                    this.proposalContentCancel();
                }
            });
        },
        renameContent(proposalContent){
            this.selectedContent = proposalContent;
            this.proposalContentName = proposalContent.template_name;
            this.proposalContentModalButton = 'Rename';
            this.proposalContentModalTitle = 'Rename Section Content';
            $('#proposal-content-add').modal('show');
        },
        deleteContent(proposalContent){
            Swal.fire({
                title             : "Are you sure?",
                text              : "Once deleted, you will not be able to recover this content!",
                icon              : "warning",
                buttons           : true,
                showCancelButton  : true,
                confirmButtonColor: 'red',
                confirmButtonText : 'I\'m sure!',
                closeOnConfirm    : true,
                closeOnCancel     : true,
            }).then(result => {
                if (result.value) {
                    axios.post(route('api.proposal-content.delete'), {content: proposalContent}).then((response) => {
                        if(response.data.status == 'success'){
                            this.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                            this.page = 1;
                            this.fetchproposalContents();
                        }
                    });
                }
            });
        },
        manageContent(proposalContent){
            if(proposalContent.section_type == 0){
                Bus.$emit('changeSettingType', {selectedData: proposalContent, type:'content-pdf-manage'});
            }else if(proposalContent.section_type == 1){
                Bus.$emit('changeSettingType', {selectedData: proposalContent, type:'content-text-manage'});
            }else if(proposalContent.section_type == 2){
                Bus.$emit('changeSettingType', {selectedData: proposalContent, type:'content-sheet-manage'});
            }else if(proposalContent.section_type == 3){
                Bus.$emit('changeSettingType', {selectedData: proposalContent, type:'content-quote-and-pricing-template'});
            }
        },
        updateProposalContentName(){
            if(this.proposalContentName.trim() == '' || this.proposalContentName == undefined){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please enter content name'
                });
                return false;
            }
            axios.post(route('api.proposal-content.rename'), {name:this.proposalContentName, content: this.selectedContent}).then((response) => {
                if(response.data.status == 'success'){
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    this.page = 1;
                    this.fetchproposalContents();
                    this.proposalContentCancel();
                }
            });
        },
        duplicateContent(proposalContent){
            axios.post(route('api.proposal-content.duplicate'), {content: proposalContent}).then((response) => {
                if(response.data.status == 'success'){
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    this.page = 1;
                    this.fetchproposalContents();
                }
            });
        },
        sortByColumn(sortBy){
            if(this.currentOrder.direction == 'desc'){
                this.currentOrder = {
                    'direction':'asc',
                    'sortBy':sortBy
                };
            }else{
                this.currentOrder = {
                    'direction':'desc',
                    'sortBy':sortBy
                };
            }
            this.fetchproposalContents();
        }
    }
};
</script>

<style>
#proposal-settings-template-div {
    padding: 5px 0;
}
#proposal-settings-template-div h5{
    color: #222;
    font-weight: 400;
    padding: 5px 0px;
}
#proposal-settings-template-div .add-new-template-button{
    height: 40px;
    font-weight: 300;
}
.proposal-template-listing-heading-row{
    background: #f4f5f6;
    font-weight: 500;
}
.proposal-template-listing-row {
    font-weight: 300;
}
.proposal-template-listing-row .dropdown-item {
    font-weight: 300;
    font-size: 15px;
}
.proposal-template-listing-row:hover {
    background: #f5f5f5;
}

.red-box-shadow{
    box-shadow: 0px 0px 5px #01b1af;
}
input#searchContent {
    width: 70%;
    float: left;
}
</style>
